import { Box, Button, ButtonOwnProps, Typography } from '@mui/material';
import AddButtonRounded from '@Components/AddButtonRounded';

const Buttons = () => {
  const colors = [
    'primary',
    'secondary',
    'success',
    'error',
    'info',
    'warning',
    'inherit',
  ];

  return (
    <Box>
      <Typography variant="h3">Button</Typography>
      <Box display={'flex'} gap={2} mt={2} flexWrap={'wrap'}>
        {colors.map((color, index) => (
          <Box
            key={index}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
            minWidth={250}
            gap={1}
          >
            <Typography variant="subtitle2">Button {color}</Typography>
            <Button color={color as ButtonOwnProps['color']}>
              Button Contained
            </Button>
            <Button color={color as ButtonOwnProps['color']} disabled>
              Button Contained Disabled
            </Button>
            <Button color={color as ButtonOwnProps['color']} variant={'text'}>
              Button Text
            </Button>
            <Button
              color={color as ButtonOwnProps['color']}
              variant={'text'}
              disabled
            >
              Button Text Disabled
            </Button>
          </Box>
        ))}
      </Box>

      <Typography variant="h3" mt={3}>
        Custom Button
      </Typography>
      <AddButtonRounded name="ทดสอบปุ่มเพิ่มข้อมูล" />
    </Box>
  );
};

export default Buttons;
